
export const alankaramConstant = [
    {
        domain: ["3d.alankaram.in","localhost:3001"],
        parts: [
            {
                id: 1,
                name: "All Products",
                key: "All Products",
                image: '/Alankaram/all_products.jpg',
                selected: false,
            },
            { id: 2, name: "Sofa", image: '/Alankaram/Sofa.jpg', selected: true, key: "Sofa" },
            { id: 3, name: "Chair", image: '/Alankaram/chair.jpg', selected: false, key: "Chair" },
            {
                id: 4,
                name: "Office Table",
                image: '/Alankaram/wroksation.jpg',
                selected: false,
                key: "Office Table"
            },
            { id: 5, name: "Kitchen", image: '/Alankaram/kitchen.jpg', selected: false, key: "Kitchen" },
            {
                id: 6,
                name: "Storage Cabinets",
                image: '/Alankaram/cabinet.jpg',
                selected: false,
                key: "Storage Cabinets"
            },
            {
                id: 7,
                name: "Tables",
                image: '/Alankaram/diningtable.jpg',
                selected: false,
                key: "Tables"
            },
            {
                id: 8,
                name: "Bed",
                image: '/Alankaram/bed.jpg',
                selected: false,
                key: "Bed"
            },
        ],
        companyId: "63e0c85267e6ab00082da07e",
        companyName: "Alankaram",
        logo: "/Alankaram/alankaramLogo.png",
        mobile: '+919723353062', 
        email: 'design@alankaram.in',
        heroImage: '/Alankaram/hero_image.png',
        title:"Alankaram – Handcrafted Luxury Furniture | Premium Teakwood Designs",
        headingTagline:"Exclusive Furnitures Made Only For You",
        subHeadingTagline:"Make your house a home with our wide collection of beautiful furniture",
        backgroundImage:"/Alankaram/alankaram_login.png",
        favicon:"/FaviconIco.png",
        GTAG_ID:"G-WGK3LFFJNE"
    },  
    {
        domain: ["3d.panamprojects.com","192.168.1.20:3000"],
        parts: [
            {
                id: 1,
                name: "All Products",
                key: "All Products",
                image: '/Panam/allproducts.jpg',
                selected: false,
            },
            { id: 2, name: "Director Table", image: '/Panam/TwainmanagerTablefront_frosty-Photoroom.png', selected: true, key: "Director Table" },
            // { id: 3, name: "Executive Table", image: '/Panam/Goldfinch_ExecutiveTablefron-che-Photoroom.png', selected: false, key: "Executive Table" },
            { id: 4, name: "Work Station", image: '/Panam/Axis_Workstation_7-legs-Photoroom.png', selected: false, key: "Workstation" },
            { id: 5, name: "Conference Table", image: '/Panam/ConferenceTable_04_1-SHEDO-Photoroom.png', selected: false, key: "Tables" },
            { id: 6, name: "Exectuive Premium Series", image: '/Panam/chair-thumb-2.png', selected: false, key: "Chair" },
            { id: 7, name: "Smart Premium Series", image: '/Panam/chair-thumb.png', selected: false, key: "Chair" },
            
        ],
        companyId: "61ebf6cf966a8800095175d5",
        companyName: "Panam",
        logo: "/Panam/panam_logo-old.png",
        mobile: '+919723353062', 
        email: 'design@panamprojects.com',
        heroImage: '/Panam/studio-arrangement-work.jpg',
        title:"Panam Projects - Modular Furniture Manufacturer",
        headingTagline:"Exclusive Furnitures Made Only For You",
        subHeadingTagline:"Make your house a home with our wide collection of beautiful furniture",
        backgroundImage:"/Panam/studio-arrangement-work.jpg",
        favicon:"/Panam/panam_logo.png",
        GTAG_ID:"G-HJ1KZK6Z5D"
    },
    {
        domain: ["3d.indicors.com","192.168.1.18:3000"],
        parts: [
            {
                id: 1,
                name: "All Products",
                key: "All Products",
                image: '/indicor/allproduct.jpg',
                selected: false,
            },
            { id: 2, name: "Home Furniture", image: '/indicor/home.jpg', selected: true, key: "Tables" },
            { id: 3, name: "Office Funiture", image: '/indicor/office.jpg', selected: false, key: "Workstation" },
            { id: 4, name: "Decor", image: '/indicor/decor.jpg', selected: false, key: "decor" },
            
            
        ],
        companyId: "5feac293447a060008714d9f",
        companyName: "Indicor",
        logo: "/indicor/indicor-logo.png",
        mobile: '+918000022520', 
        email: 'sales@indicors.com',
        heroImage: '/indicor/hero-image.jpg',
        title:"Indicor Studio - Future-Ready Furniture Solutions",
        headingTagline:"Crafting Tomorrow's Workspaces Today",
        subHeadingTagline:"Innovative Furniture Designs for Modern Offices",
        backgroundImage:"/indicor/background.jpg",
        favicon:"/indicor/ind-fav.png",
        GTAG_ID:"G-HJ1KZK6Z5D"
    },
]